import { useState } from 'react'
import styles from './dishesCard.module.css'
import arrowPrev from '../../assets/icons/arrowLeft.svg'
import arrowNext from '../../assets/icons/arrowRight.svg'
import iconPrice from '../../assets/icons/IconPrice.svg'
import noImage from '../../assets/img/no-image.jpg'
import { ImageType } from '../../pages/MainPage/MainPage'
import { Slide } from 'react-slideshow-image'

import CreateProductModal from '../CreateProductModal/CreateProductModal'
import { changeProductMainInformation, getCurrentProduct } from '../../redux/actions/productsActon'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { resetCurrentProduct } from '../../redux/reducers/products/productsSlice'

interface DishesCardProps {
  name: string
  images: ImageType[]
  price: number
  description: string
  weight: number | string
  menuId: string
  category: string
  measurement: string
  quantity: number
  id: number
}
const DishesCard: React.FC<DishesCardProps> = ({
  name,
  images,
  price,
  description,
  weight,
  measurement,
  quantity,
  id,
  menuId,
}) => {
  const dispatch = useAppDispatch()
  const [count, setCount] = useState(quantity)
  // const [_totalprice, _setTotalPrice] = useState(count > 1 ? totalPrice : price);
  const [_price, _setPrice] = useState(price)
  const [isProductEditing, setIsProductEditing] = useState<boolean>(false)
  const { token } = useAppSelector((state) => state.auth)
  const { currentProduct } = useAppSelector((state) => state.products)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleArrowClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const properties = {
    canSwipe: false,
    duration: 5000,
    autoplay: false,
    transitionDuration: 500,
    arrows: false,
    infinite: true,
    easing: 'ease',
    indicators: () => <div className='sliderIndicator'></div>,
    prevArrow: (
      <div className={styles.arrowPrevBlock} onClick={handleArrowClick}>
        <img className={styles.arrowPrev} src={arrowPrev} alt='arrowPrev' />
      </div>
    ),
    nextArrow: (
      <div className={styles.arrowNextBlock} onClick={handleArrowClick}>
        <img className={styles.arrowNext} src={arrowNext} alt='arrowNext' />
      </div>
    ),
  }

  const handleEditProduct = async () => {
    setIsProductEditing(true)
    setIsOpen(true)
    await dispatch(getCurrentProduct({ productId: String(id), token }))
  }
  const edit = async () => {
    const result = await dispatch(
      changeProductMainInformation({
        productId: currentProduct.id,
        token,
        quantity: String(count), // Send updated quantity
      }),
    )

    await dispatch(getCurrentProduct({ productId: String(id), token }))
  }

  return (
    <>
      <div onClick={handleEditProduct} className={styles.dishesCard}>
        <div className={styles.left}>
          <div className={styles.slider}>
            {images.length !== 0 ? (
              <Slide {...properties} cssClass='sliderContainer'>
                {images.map((slideImage, index) => {
                  return (
                    <div
                      key={index}
                      className={styles.slideImage}
                      style={{
                        backgroundImage: `url("${`${process.env.REACT_APP_BASE_URL_IMAGES}/${slideImage.src}`}")`,
                        zIndex: 0,
                      }}
                    ></div>
                  )
                })}
              </Slide>
            ) : (
              <div className={styles.slideImage}>
                <img className={styles.slideImage} src={noImage} alt='noImage' />
              </div>
            )}
          </div>
        </div>
        <div className={styles.centralBlock}>
          <div className={styles.center}>
            <h3>{name.length > 25 ? `${name.substring(0, 25)}...` : name}</h3>
            <h5>{description.length > 35 ? `${description.substring(0, 35)}...` : description}</h5>
          </div>
          <div className={styles.price}>
            <div className={styles.priceWrapper}>
              <img src={iconPrice} alt='iconPrice' />
              <h3 style={{ textAlign: 'right' }}>{price} руб</h3>
            </div>
            <h5>
              {weight} {measurement}
            </h5>
          </div>
        </div>
      </div>
      <CreateProductModal
        menuId={menuId}
        isReadOnlyMode={true}
        isEditMode={isProductEditing}
        isOpen={isProductEditing || isOpen}
        onClose={() => {
          setIsOpen(false)
          setIsProductEditing(false)
          dispatch(resetCurrentProduct())
        }}
        currentProduct={currentProduct}
      />
    </>
  )
}

export default DishesCard
